import { ref, inject, type Ref } from 'vue'

export type Breakpoints = {
  [key in keyof typeof BREAKPOINTS]: Ref<boolean>
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $breakpoints: Breakpoints
  }
}


// Update when updating tailwind config
export const BREAKPOINTS = {
  'sm': '640px',
  'md': '768px',
  'lg': '1024px',
  'xl': '1280px',
  '2xl': '1536px'
}

export const key = Symbol('breakpoints')
export const useBreakpoints = () => inject(key) as Breakpoints

const breakpoint = (size) => {
  const mq = window.matchMedia(`(max-width: ${size})`)
  const breakpoint = ref(mq.matches)
  mq.addEventListener('change', () => breakpoint.value = mq.matches)
  return breakpoint
}

export default {
  install(app) {
    const breakpoints = Object.entries(BREAKPOINTS).reduce((obj, [ key, value ]) => {
      obj[key] = breakpoint(value)
      return obj
    }, {} as Breakpoints)
    app.provide(key, breakpoints)
    app.config.globalProperties.$breakpoints = breakpoints
  }
}
